export default class ApiError {
	static NO_ERROR = 0;

	// Common
	static INVALID_REQUEST = 1;
	static INVALID_FORMAT = 2;
	static ALREADY_EXIST = 3;
	static NOT_FOUND = 4;
	static PERMISSION_DENIED = 5;
	static INVALID_CLIENT_ID = 6;
	static RETRY_REQUEST = 7;
	static INVALID_STATUS = 8;
	static INVALID_ROLE = 9;
	static INVALID_TOKEN = 10;
	static INVALID_TOKEN_PAIRN = 11;
	static INVALID_API_LOGIN_TOKEN = 12;
	static INVALID_ROUTE = 13;
	static INVALID_SIGNATURE = 14;

	// Database
	static DB_UNHANDLED_EXCEPTION = 101;
	static DB_DUPLICATED_ENTRY = 102;

	// Coupon
	static COUPON_NOT_FOUND = 201;
	static COUPON_INVALID = 202;

	// User
	static USER_NOT_FOUND = 301;
	static USER_INVALID = 302;
	static USER_ALREADY_EXIST = 303;
	static USER_NOT_BINDED = 304;

	// Member
	static PASSWORD_CHANGED_REQUIRED = 601;
	static PASSWORD_EXPIRED = 602;
	static ACCOUNT_IS_INACTIVE = 603;
	static PASSWORD_FORMAT_ERROR = 604;
	static INVALID_USER_OR_PASSWORD = 605;
	static INVALID_PASSWORD = 606;
	static INVALID_VERIFICATION_CODE = 607;
	static VERIFICATION_CODE_IN_COOLDOWN = 608;
	static VERIFICATION_CODE_EXPIRED = 609;
	static VERIFICATION_CODE_FAILED_TOO_MANY_TIMES = 610;
	static VERIFICATION_CODE_CANNOT_SEND = 611;
	static LOGIN_FAILED_COUNT_LIMIT = 612;
	static PASSWORD_LOGIN_IS_DISABLED = 613;
	static GET_LINE_ACCESS_TOKEN_FAILED = 614;
	static MOBILE_USED = 615;
	static INVALID_MOBILE = 616;
	static ALREADY_RESERVED = 617;
	static MOBILE_BINDED = 618;

	static MEMBER_SALES_BINDING_ALREADY_EXISTS = 1302;
	static MEMBER_SALES_BINDING_IS_NOT_EMPTY = 1303;

	static CUSTOMER_TOKEN_IS_NOT_FOUND = 1308;
	static CUSTOMER_TOKEN_VERIFICATION_EXPIRED = 1309;
}
